export default __webpack_public_path__ + "static/media/microgramma-d-bold-extended.9d81240c.otf";